<template>
    <div>
        <top-nav v-if="stageType==1" :active="'/asmt/index'"></top-nav>
        <mobileTopNav v-if="stageType==2" title="心理测评"></mobileTopNav>

        <div class="asmtBox mw">
            <div class="topTabBar">
                <div :class="'topTabItem '+(tabKey==n.key?'topTabSel':'')" v-for="(n,i) in tabOptions" :key="i" @click="toggleTab(n.key)">{{ n.label }}<div class="ttBotLine"></div>
                </div>
            </div>

            <div class="welTip">欢迎登录，{{showName}}</div>

            <template v-if="tabKey=='joinIn'">
                <div class="asmtItem" v-for="(n,i) in table.records" :key="i" @click="toDetail(n)">
                    <!-- <div class="asmtImg" :style="'background-image: url('+fileHost+n.asmt.cover+')'"></div> -->
                    <div class="asmtImgBox">
                        <el-image v-if="n.asmt.cover" class="asmtImg" :src="fileHost+n.asmt.cover" fit="cover"></el-image>
                        <div v-else class="asmtImg asmtImgFallback" :style="getCoverGradient(n.asmt.asmtName)">{{ n.asmt.asmtName }}</div>
                        <div class="asmtStatusTag" :style="getStatusStyle(n.status)">{{ n.statusFmt }}</div>
                        <div v-if="n.status == 1" class="asmtStartBtn">
                            <el-button type="primary" size="medium" icon="el-icon-right">开始测评</el-button>
                        </div>
                    </div>
                    <div class="asmtName dots">{{ n.asmt.asmtName }}</div>
                    <div class="asmtTime" v-if="n.asmtOrg">{{ n.asmtOrg.beginTimeDay }} ~ {{ n.asmtOrg.endTimeDay }}</div>
                    <div class="asmtTime" v-else>{{ n.asmt.beginTimeDay }} ~ {{ n.asmt.endTimeDay }}</div>
                </div>
                <el-empty v-if="table.records.length==0" description="暂无数据" :image-size="120"></el-empty>

                <div class="clear20"></div>
            </template>
            <template v-if="tabKey=='hot'">
                <div class="asmtItem" v-for="(n,i) in table.records" :key="i" @click="toHotAsmt(n)">
                    <!-- <div class="asmtImg" :style="'background-image: url('+fileHost+n.cover+')'"></div> -->
                    <el-image class="asmtImg" :src="fileHost+n.cover" fit="cover"></el-image>
                    <div class="asmtName dots">{{ n.asmtName }}</div>
                    <div class="asmtTime">{{ n.beginTimeDay }} ~ {{ n.endTimeDay }}</div>
                </div>
                <el-empty v-if="table.records.length==0" description="暂无数据" :image-size="120"></el-empty>

                <div class="clear20"></div>
            </template>
        </div>
        <div class="botPages">
            <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page="table.current" :page-size="table.size" layout="total, prev, pager, next"
                :total="table.total">
            </el-pagination>
        </div>

        <bot-nav v-if="stageType==1"></bot-nav>

        <el-dialog :title="centerDialogTit" :custom-class="dialogClass" :width="centerDialogWidth" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true"
            :visible.sync="centerDialogVisible" :fullscreen="centerDialogFs" v-if="centerDialogVisible" append-to-body>
            <component :is="centerComp.con" :key="centerComp.ts" :param="centerComp.param" @closeCallback="centerDialogVisible=false" @confirmCallback="centerConfirmCallback"></component>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "index",
    components: {},
    data() {
        return {
            sysName: config.sysName,
            showName: '',
            stageType: '',
            queryForm: {},
            tableSource: {
                size: 10,
                current: 1,
                pages: 0,
                total: 0,
                records: [],
            },
            table: {
                size: 10,
                current: 1,
                pages: 0,
                total: 0,
                records: [],
            },
            fileHost: config.fileHost,

            tabKey: '',
            tabOptions: [
                {
                    label: '我参与的',
                    key: 'joinIn',
                },
                {
                    label: '热门测评',
                    key: 'hot',
                },
            ],

            centerDialogTit: '',
            centerDialogWidth: '660px',
            dialogClass: '',
            centerDialogFs: false,
            centerDialogVisible: false,
            centerComp: {},
        };
    },
    methods: {
        toggleTab(key) {
            this.table = JSON.parse(JSON.stringify(this.tableSource));

            this.tabKey = key;
            if (key == 'joinIn') {
                this.getJoinData();
            } else if (key == 'hot') {
                this.getHotData();
            }
        },
        getCoverGradient(name) {
            return 'background: linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)';
        },
        getStatusStyle(status) {
            const colors = {
                1: { background: '#909399' },
                2: { background: '#E6A23C' },
                3: { background: '#67C23A' }
            };
            return colors[status] || colors[1];
        },
        toViewCust: function () {
            this.centerComp = {
                con: () => import('@/components/asmt/cust_info.vue'),
                ts: new Date().getTime(),
                param: {},
            };
            this.centerDialogTit = '请确认个人信息';
            this.centerDialogWidth = this.lib.popWidth(660, 0.9);
            this.dialogClass = '';
            this.centerDialogFs = false;
            this.centerDialogVisible = true;
        },
        toDetail: function (row) {
            if (row.asmt.confirmReq && row.confirmStatus != 1) {
                this.$message.error('未签署《知情同意书》，暂不可参与测评！');
                return;
            }

            this.$router.push({ path: '/asmt/asmt_record', query: { recordId: row.id } });

            // this.centerComp = {
            //     con: () => import('@/components/asmt/confirm_tip.vue'),
            //     ts: new Date().getTime(),
            //     param: {
            //         recordId: row.id,
            //         content: row.asmt.confirmContent
            //     },
            // };
            // this.centerDialogTit = '知情同意书';
            // this.centerDialogWidth = this.lib.popWidth(660, 0.9);
            // this.dialogClass = '';
            // this.centerDialogFs = false;
            // this.centerDialogVisible = true;
        },
        toHotAsmt: function (n) {
            this.centerComp = {
                con: () => import('@/components/asmt/comp/join_asmt.vue'),
                ts: new Date().getTime(),
                param: {
                    asmt: n,
                },
            };
            this.centerDialogTit = n.asmtName;
            this.centerDialogWidth = this.lib.popWidth(660, 0.9);
            this.dialogClass = '';
            this.centerDialogFs = false;
            this.centerDialogVisible = true;
        },
        centerConfirmCallback: function (param) {
            if (param && param.code) {
                if (param.code == 'cust_ok') {
                    this.centerDialogVisible = false;
                } else if (param.code == 'confirm_ok') {
                    this.centerDialogVisible = false;
                    this.$router.push({ path: '/asmt/asmt_record', query: { recordId: param.recordId } });
                } else if (param.code == 'to_record_detail') {
                    this.centerDialogVisible = false;
                    this.toDetail(param.obj);
                }
            }
        },

        search: function () {
            this.table.current = 1;
            if (this.tabKey == 'joinIn') {
                this.getJoinData();
            } else if (this.tabKey == 'hot') {
                this.getHotData();
            }
        },
        reset: function () {
            this.queryForm = {};
            if (this.tabKey == 'joinIn') {
                this.getJoinData();
            } else if (this.tabKey == 'hot') {
                this.getHotData();
            }
        },
        sizeChange: function (size) {
            this.table.size = size;
            if (this.tabKey == 'joinIn') {
                this.getJoinData();
            } else if (this.tabKey == 'hot') {
                this.getHotData();
            }
        },
        currentChange: function (current) {
            this.table.current = current;
            if (this.tabKey == 'joinIn') {
                this.getJoinData();
            } else if (this.tabKey == 'hot') {
                this.getHotData();
            }
        },
        getJoinData: function () {
            let _this = this;
            let param = JSON.parse(JSON.stringify(_this.queryForm));
            param.pageSize = _this.table.size;
            param.pageIndex = _this.table.current;
            param.buildDetail = true;

            this.req('/pap_asmt_record_page', param, function (data) {
                if (data.success) {
                    _this.table = data.obj;
                }
            });
        },
        getHotData: function () {
            let _this = this;
            let param = JSON.parse(JSON.stringify(_this.queryForm));
            param.pageSize = _this.table.size;
            param.pageIndex = _this.table.current;
            param.joinWay = 1;

            this.req('/pap_asmt_page', param, function (data) {
                if (data.success) {
                    _this.table = data.obj;
                }
            });
        },
    },
    mounted: function () {

        this.$nextTick(function () {
            let _this = this;
            this.uid = sessionStorage.getItem("uid");
            this.showName = sessionStorage.getItem("showName");
            this.stageType = sessionStorage.getItem("stageType");
            let type = sessionStorage.getItem("type");

            if (type == 21) {
                if (!sessionStorage.getItem("showCust")) {
                    this.toViewCust();
                    sessionStorage.setItem("showCust", 'yes')
                }
            }

            this.toggleTab('joinIn');
            // let date = this.lib.timeFormat(new Date(), 'yyyy-mm-dd');
            // this.$watermark.set(this.uid + "/" + this.realName + ' ' + date)

        });
    },
    beforeDestroy: function () {
        // this.$watermark.remove();
    },
};
</script>
<style scoped>
.botPages {
    text-align: center;
}
.welTip {
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    padding: 10px 0 20px;
    color: #077cf5;
}
.asmtBox {
    box-sizing: border-box;
    padding: 10px 0 30px 20px;
    min-height: 600px;
}
.asmtItem {
    width: 373px;
    height: auto;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
}
.asmtImg {
    width: 100%;
    height: 210px;
    background-size: cover;
    background-position: center;
    border-radius: 10px;
}
.asmtImgBox {
    position: relative;
}
.asmtImgFallback {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    padding: 10px;
    word-break: break-all;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
    user-select: none;
}
.asmtStatusTag {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
}
.asmtStartBtn {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
}
.asmtName {
    font-size: 16px;
    font-weight: bold;
    margin-top: 5px;
}
.asmtTime {
    margin-top: 5px;
}

.topTabBar {
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: flex;
    border-bottom: 1px solid #eee;
    background-color: #fff;
    margin-bottom: 20px;
}
.topTabItem {
    flex: 1;
    color: #888;
    position: relative;
    text-align: center;
    cursor: pointer;
}
.topTabSel {
    color: #232323;
}
.ttBotLine {
    width: 50px;
    height: 3px;
    border-radius: 2px;
    background-color: #077cf5;
    position: absolute;
    z-index: 1;
    left: calc(50% - 25px);
    bottom: 0px;
    display: none;
}
.topTabSel .ttBotLine {
    display: block;
}

@media (max-width: 770px) {
    .asmtItem {
        width: 100%;
        height: auto;
        float: none;
        margin-right: 0px;
    }
    .asmtBox {
        padding: 10px 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/asmt/index.vue